import { PageShell } from "@/components/site/PageShell";
import { PageHeader } from "@/components/site/PageHeader";
import { Energy } from "@/components/landing/Energy";
import { ConstructionTracker } from "@/components/landing/ConstructionTracker";
import { BuyingTimeline } from "@/components/landing/BuyingTimeline";
import { Funding } from "@/components/landing/Funding";
import { LocationMap } from "@/components/landing/LocationMap";
import { Reveal } from "@/hooks/useReveal";
import { SeoHead } from "@/components/SeoHead";
import { PAGE_SEO, resolveSeo } from "@/data/apartmentSeo";
import { useT, useLang } from "@/i18n/LanguageProvider";

/**
 * ArchitekturPage – the "architecture, energy & process" sub-page.
 * Combines the energy concept (EH 40, heat pump, PV), the live
 * construction tracker, the funding/KfW block, the buying timeline
 * and the location, for visitors who want to dig into the technical
 * and procedural depth of G21.
 */
export default function ArchitekturPage() {
    const { lang } = useLang();
    const seo = resolveSeo(PAGE_SEO.architektur, lang);
    const t = useT();

    return (
        <PageShell testId="architektur-page">
            <SeoHead seo={seo} />
            <PageHeader
                eyebrow={t({ de: "Architektur · Energie · Ablauf", en: "Architecture · Energy · Process" })}
                title={t({ de: "Effizienzhaus 40 mit", en: "Energy class 40 with" })}
                titleAccent={t({ de: "Charakter.", en: "character." })}
                subtitle={t({
                    de: "Klassische Dachform, modernes Detail, eigene Wärmepumpe je Wohnung und inklusive 2 kW Photovoltaik-Anlage mit Speicher. Und ein klar nachvollziehbarer Bauablauf – Schritt für Schritt vom Kennenlernen bis zur Übergabe.",
                    en: "Classic roof shape, modern detail, dedicated heat pump per apartment and an included 2 kW PV system with battery storage. Plus a transparent build process – step by step from first meeting to handover.",
                })}
                breadcrumb={[
                    { label: t({ de: "Start", en: "Home" }), to: "/" },
                    { label: t({ de: "Architektur & Energie", en: "Architecture & energy" }) },
                ]}
                bg="sand"
                testId="architektur-header"
            />

            <Reveal><Energy /></Reveal>
            <Reveal><ConstructionTracker /></Reveal>
            <Reveal><Funding /></Reveal>
            <Reveal><BuyingTimeline /></Reveal>
            <Reveal><LocationMap /></Reveal>
        </PageShell>
    );
}
